export enum MapMode {
  Single = "single",
  Multiple = "multiple",
}